enum MaintenanceRegisteredEntityType {
  Unknown = "unknown",
  Role = "role",
  User = "user",
}

export { MaintenanceRegisteredEntityType };
